<template>
  <el-tag
    :type="tagType"
    :effect="effect"
    size="small">
    {{ label }}
  </el-tag>
</template>

<script>
export default {
  name: 'StatusTag',
  props: {
    status: {
      type: [String, Number],
      required: true
    },
    statusMap: {
      type: Object,
      required: true
    },
    effect: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    tagType() {
      return this.statusMap[this.status]?.type || 'info'
    },
    label() {
      return this.statusMap[this.status]?.label || '未知'
    }
  }
}
</script> 